const TechnicalTab = ({ booking }) => {
  const technical = booking.technical_info || {};

  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 text-sm p-4">
      {/* LEFT – Venue Info */}
      <div className="lg:col-span-2 bg-slate-900/80 border border-white/10 rounded-lg p-4">
        <h3 className="text-white font-semibold mb-5">Venue Informations</h3>

        <LinkInfo label="Sounds Rider" url={technical.sound_rider} />
        <LinkInfo label="Lighting Plot" url={technical.lightning_plot} />
        <LinkInfo label="LED Plot" url={technical.led_plot} />
        <Info
          label="Other Technical Info"
          value={technical.other_technical_info}
        />

        <div className="mt-6">
          <Info label="LD Contact" value={technical.ld_contact} />
          <Info label="VJ Contact" value={technical.vj_contact} />
          <Info label="Technical Contact" value={technical.technical_contact} />
        </div>
      </div>

      {/* RIGHT – DJ Booth Technical */}
      <div className="lg:col-span-2 bg-slate-900/80 border border-white/10 rounded-lg p-4">
        <h3 className="text-white font-semibold mb-5">
          DJ Booth Technical Info
        </h3>

        {/* Monitoring System */}
        <div className="mb-6">
          <h4 className="text-slate-300 mb-2">Monitoring System</h4>

          <Info label="TOPs Brand" value={technical.tops_brand} />
          <Info label="TOPs QTY" value={technical.tops_qty} />
          <LinkInfo
            label="Technical Info Link"
            url={technical.tops_technical_info_link}
          />
          <Info label="SUBs Brand" value={technical.subs_brand} />
          <Info label="SUBs QTY" value={technical.subs_qty} />
          <LinkInfo
            label="Technical Info Link"
            url={technical.subs_technical_info_link}
          />
        </div>

        {/* DJ Setup */}
        <div>
          <h4 className="text-slate-300 mb-2">DJ Setup</h4>

          <Info label="No of Players" value={technical.no_of_players} />
          <Info label="Type of Players" value={technical.type_of_players} />
          <Info label="Mixer Type" value={technical.mixer_type} />
        </div>
      </div>
    </div>
  );
};

const Info = ({ label, value }) => (
  <div className="mb-2">
    <p className="text-slate-400">{label}</p>
    <p className="text-white">{value || "-"}</p>
  </div>
);

const LinkInfo = ({ label, url }) => (
  <div className="mb-2">
    <p className="text-slate-400">{label}</p>

    {url ? (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-pink-500 hover:underline break-all"
      >
        Open Link
      </a>
    ) : (
      <p className="text-white">-</p>
    )}
  </div>
);

export default TechnicalTab;
